/*
 index

 Główny plik strony  
 Renderowanie w miejscu wyznaconym rzez element root
 
 historia: 
  04-2019 JW - start
  04-05-2019 - rezygnacja z redux-react-hook
*/

import React, { Suspense }  from "react";

import ReactDOM from "react-dom";

import { Provider } from 'react-redux';

//import { StoreContext } from 'redux-react-hook'; // https://github.com/facebookincubator/redux-react-hook

//import { BrowserRouter, Route, Link } from 'react-router-dom';
import { Router } from "react-router";
import {
  //BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { createBrowserHistory } from 'history';

import App from './App';

import { store } from './appredux';

import i18n from './cfg/i18n'; // (needs to be bundled ;))

import { I18nextProvider } from 'react-i18next';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';

// transfers sessionStorage from one tab to another
// var sessionStorage_transfer = function(event: any) {
//   if(!event) { event = window.event; } // ie suq
//   if(!event.newValue) return;          // do nothing if no value to work with
//   if (event.key == 'getSessionStorage') {
//     // another tab asked for the sessionStorage -> send it
//     localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
//     // the other tab should now have it, so we're done with it.
//     localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
//   } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
//     // another tab sent data <- get it
//     var data = JSON.parse(event.newValue);
//     for (var key in data) {
//       sessionStorage.setItem(key, data[key]);
//     }
//   }
// };

// listen for changes to localStorage
// if(window.addEventListener) {
//   window.addEventListener("storage", sessionStorage_transfer, false);
// } 
// else {
//   window.attachEvent("onstorage", sessionStorage_transfer);
// };


// Ask other tabs for session storage (this is ONLY to trigger event)
// if (!sessionStorage.length) {
//   localStorage.setItem('getSessionStorage', 'foobar');
//   localStorage.removeItem('getSessionStorage');
// };

const Loader = () => <div>loading...</div>;
const hist = createBrowserHistory(); 

ReactDOM.render(
<I18nextProvider i18n={i18n as any}>
    <Provider store={store}>
        {/* <Router history={hist}> */}
          <Suspense fallback={<Loader />}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
             <App/>
          </MuiPickersUtilsProvider>
          </Suspense>
        {/* </Router> */}
    </Provider>
</I18nextProvider>
,
    document.getElementById('root')
  );
